<script setup></script>

<template>
  <div>Top 10 Table</div>
</template>

<style scoped></style>
